import { useState } from 'react';
import { useLocalization } from '@/hooks/useLocalization';
import { useLead } from '@/hooks/useLead';
import { useChat } from '@/hooks/useChat';
import BotMessage from '@/components/ChatMessage/BotMessage';
import OptionButton from '@/components/OptionButton/OptionButton';
import { validateEmail } from '@/utils/validators';
import styles from '@/styles/chat.module.scss';
import formStyles from '@/styles/forms.module.scss';

const DownloadIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
  </svg>
);

export default function GuideScreen() {
  const { t } = useLocalization();
  const { leadData, setEmail } = useLead();
  const { submitGuideEmail } = useChat();
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    const err = validateEmail(leadData.email);
    setError(err);
    if (err) return;

    setIsSubmitting(true);
    try {
      await submitGuideEmail();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <BotMessage text={t('guide.message')}>
      <div className={styles.guideCard}>
        <div className={styles.guideCover}>
          <div className={styles.guideBook}>
            <div className={styles.guideLogo}>IBC</div>
            <div className={styles.guideLabel}>{t('guide.badge')}</div>
          </div>
        </div>

        <div className={styles.guideInfo}>
          <p className={styles.guideTitle}>{t('guide.title')}</p>
          <ul className={styles.guidePoints}>
            <li>{t('guide.point1')}</li>
            <li>{t('guide.point2')}</li>
            <li>{t('guide.point3')}</li>
          </ul>
        </div>
      </div>

      <div className={formStyles.emailForm}>
        <label className={formStyles.label} htmlFor="ibc-guide-email">
          {t('guide.emailLabel')}
        </label>
        <input
          id="ibc-guide-email"
          className={[formStyles.input, error ? formStyles.error : ''].filter(Boolean).join(' ')}
          type="email"
          placeholder={t('contacts.emailPlaceholder')}
          value={leadData.email}
          onChange={(e) => {
            setEmail(e.target.value);
            if (error) setError(null);
          }}
          autoComplete="email"
        />
        {error ? (
          <span className={formStyles.errorMsg}>{error}</span>
        ) : (
          <span className={formStyles.textareaHint}>{t('guide.hint')}</span>
        )}
        <OptionButton
          variant="primary"
          onClick={handleSubmit}
          disabled={isSubmitting}
          icon={!isSubmitting ? <DownloadIcon /> : undefined}
        >
          {isSubmitting ? t('guide.sending') : t('guide.getGuide')}
        </OptionButton>
      </div>
    </BotMessage>
  );
}
